<template>
    <RowColumn type="none" class="bg-white rounded-shadow m-1">
        <div class="font-bold -bottom-10">
            {{ $t('production.productPreparation') }}
        </div>
        <div class="grid grid-cols-12 gap-4 py-5 sm:px-5">
            <div class="col-span-12 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('product.name') }}
                </div>
                <b-form-input class="border-gray-300 h-11 focus:ring-0"/>
            </div>

            <div class="col-span-12 md:col-span-4 relative ">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('production.selectMaterial') }}
                </div>
                <b-form-select
                    :options="options"
                    value-field="id"
                    text-field="shortName"
                    class="border-gray-300 h-11 focus:ring-0"
                >
                </b-form-select>
            </div>

            <div class="col-span-12 rounded md:col-span-4 relative">
                <label
                    for="image"
                    class="rounded w-full h-28 flex flex-col justify-center items-center border border-gray-300 cursor-pointer"
                >
                    <img src="/images/imageIcon.png" alt="" class="h-11 mb-2">
                    <span class="text-gray-700">{{ $t('production.selectFile') }}</span>
                    <span class="text-gray-500 text-sm">png, jpg, jpeg</span>
                    <input
                        id="image"
                        style="display: none"
                        type="file"
                        accept="image/*"
                    >
                </label>
            </div>
            <div class="col-span-12 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('productPriceModify.marja') }}
                </div>
                <b-form-input class="border-gray-300 h-11 focus:ring-0"/>
            </div>
            <div class="col-span-12 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('sellingPrice') }}
                </div>
                <b-form-select
                    :options="options"
                    value-field="id"
                    text-field="shortName"
                    class="border-gray-300 h-11 focus:ring-0"
                >
                </b-form-select>
            </div>
        </div>
        <div class="pt-2 sm:px-5">
            <div class="flex justify-between items-center">
                <b-button
                    variant="primary"
                    class="focus:ring-0 relative -top-px"
                    id="order"
                >
                    {{ $t('add') }}
                </b-button>
            </div>
        </div>
        <div class="pt-5 sm:px-5">
            <h4 class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('production.composition') }}</h4>
            <table class="w-full bg-white">
                <thead>
                <tr>
                    <th class="py-2 px-4 border-b-2 border-gray-200 hidden md:table-cell">#</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200">{{ $t('name') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 hidden md:table-cell">
                        {{ $t('production.finishedProduct.methodPreparation') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 hidden md:table-cell">
                        {{ $t('production.totalAmount') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200">{{ $t('production.afterCleaning') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200">{{ $t('production.cost') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-gray-100 pb-4" v-for="(product, index) of products" :key="index">
                    <td class="py-2 px-4 hidden md:table-cell">{{ index+1 }}</td>
                    <td class="py-2 px-4">{{ product.name }}</td>
                    <td class="py-2 px-4 hidden md:table-cell">
                        <div class="flex items-center">
                            <span class="mr-2">{{ $t('loss') }}</span>
                            <b-form-checkbox type="checkbox"></b-form-checkbox>
                        </div>
                    </td>
                    <td class="py-2 px-4 hidden md:table-cell">
                        <div class="flex items-center">
                            <b-form-input
                                value-field="id"
                                text-field="shortName"
                                class="border-gray-300 h-8 focus:ring-0 w-24 mr-1.5"
                            >
                            </b-form-input>
                            {{ $t('unitOfMeasure.pc') }}
                        </div>
                    </td>
                    <td class="py-2 px-4">
                        <div class="flex items-center">
                            <b-form-input
                                value-field="id"
                                text-field="shortName"
                                class="border-gray-300 h-8 focus:ring-0 w-24 mr-1.5"
                            >
                            </b-form-input>
                            {{ $t('unitOfMeasure.pc') }}
                        </div>
                    </td>
                    <td class="px-1 mx-1 ml-2 text-left-5">{{ product.price }}UZS</td>
                    <td class="py-2 px-5">
                        <img src="/images/Remove.svg" alt="O'chirish" class="h-6"  @click="showRemoveModal(index)">
                    </td>
                </tr>
                </tbody>
            </table>
            <!-- Remove Modal -->
            <b-modal
                hide-footer
                id="remove-product-modal"
                v-model="isRemoveModalVisible"
                :title="$t('deleteConfirmSimple')"
            >
                <div class="text-center">
                    <div class="mt-4 gap-4">
                        <b-button variant="danger mr-4" @click="removeProduct">{{ $t("delete") }}</b-button>
                        <b-button variant="secondary" @click="closeRemoveModal">{{ $t("cancel") }}</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
        <div class="col-8 col-sm-6 col-md-4 w-full bg-white pb-3 mt-4 rounded">
            <div class="flex justify-content-between px-3 mt-2">
                <div>{{ $t('production.cost') }}</div>
                <div class="font-bold">{{ '10 340 ' }} UZS</div>
            </div>
            <div class="flex justify-content-between px-3">
                <div>{{ $t('production.additionalOutputs') }}</div>
                <div class=" font-bold">{{ '1270' }} UZS</div>
            </div>
            <div class="flex justify-content-between mt-4 px-3">
                <div>{{ $t('returnProducts.totalSum') }}</div>
                <div class=" font-bold">{{ '11 610' }} UZS</div>
            </div>
        </div>
        <div class="pt-2 sm:px-5">
            <div class="flex justify-between items-center">
                <b-button
                    variant="primary"
                    class="focus:ring-0 relative -top-px"
                    id="order"
                >
                    {{ $t('save') }}
                </b-button>
            </div>
        </div>
    </RowColumn>
</template>

<script>
import {mapActions} from "vuex";
import RowColumn from "@/components/RowColumn.vue";

export default {
    components: {RowColumn},
    data() {
        return {
            isRemoveModalVisible: false,
            selectedIndex: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'production.finishedProduct.title', url: 'production/finishedProducts'},
                {name: 'add'},
            ],
            options: [
                'Gamburger noni',
                'Lavash xamiri'
            ],
            products: [
                {
                    name: 'Lavash xamiri',
                    price: '4000'
                },
                {
                    name: 'Qiyma dumaloq',
                    price: '12 000'
                }
            ]
        }
    },
    methods: {
        ...mapActions(['setBreadcrumbItems']),
        showRemoveModal(index) {
            this.selectedIndex = index
            this.isRemoveModalVisible = true
        },
        removeProduct() {
            if (this.selectedIndex !== null) {
                this.products.splice(this.selectedIndex, 1)
                this.closeRemoveModal()
            }
        },
        closeRemoveModal() {
            this.isRemoveModalVisible = false
            this.selectedIndex = null
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
}
</script>

<style>

</style>
